const mainCheckbox = document.getElementById('product_addon_checkbox_checked');
const originalAddtoCartBtn = document.querySelector('[data-original-product-submit-btn]');
const customAddtoCartBtn = document.querySelector('[data-custom-product-page-submit]');

if(mainCheckbox) {
    mainCheckbox.addEventListener('change', (event) => {
        btnToggle(mainCheckbox, event);
    });
    // originalAddtoCartBtn.style.display = 'none';
    // customAddtoCartBtn.style.display = 'flex';
    updatePopupPrices();
}
if (mainCheckbox) {
    mainCheckbox.addEventListener('click', (event) => {
        // sirf real user click pe popup
        if (!event.isTrusted) return;

        if (mainCheckbox.checked) {
            openPopup(true);
        }
    });
}

//  Toggle button visibility when gift wrap checkbox changes
function btnToggle(checkboxEl, event) {
    event.stopPropagation();
    customAddtoCartBtn.style.display = checkboxEl.checked ? 'none' : 'flex';
    originalAddtoCartBtn.style.display = checkboxEl.checked ? 'block' : 'none';
    if(checkboxEl.checked) {
        openPopup(checkboxEl.checked);
    }
}

function openPopup(isChecked) {
    const overlay = document.getElementById('popupOverlay');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';    
    popupContentSwitch(isChecked, 'checkbox-continue');
}

//  Switch between popup contents
function popupContentSwitch(isChecked, type) {
    const popupConformBox = document.querySelector('.popup_conform_content');
    const popupCustomizeBox = document.querySelector('.popup_customize_content');
    const popupClosebtn = document.querySelector('.pop_close_btn');
    // const saveGiftWrapBtn = document.querySelector('#save-gift-wrap');
    const skipGiftWrapBtn = document.querySelector('#skip-gift-wrap');

    popupCustomizeBox.style.display = isChecked ? 'block' : 'none';
    popupConformBox.style.display = isChecked ? 'none' : 'block';

    if(type === 'cart-btn-continue') {
        popupClosebtn.style.display = 'none';
        // saveGiftWrapBtn.style.display = 'none';
        skipGiftWrapBtn.style.display = 'block';
    }
    else {
        popupClosebtn.style.display = 'block';
        // saveGiftWrapBtn.style.display = 'block';
        skipGiftWrapBtn.style.display = 'none';
    }
}

// Close popup without triggering any form submission
function closePopupOnly() {
    const overlay = document.getElementById('popupOverlay');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
}

// Cancel button: close popup and add ONLY the current product (no gift wrap)
function closePopup() {
    closePopupOnly();
    if (originalAddtoCartBtn) {
        originalAddtoCartBtn.click();
    }
}

// Update popup prices dynamically from product addon variant data
function updatePopupPrices() {
    const productAddonItem = document.querySelector('.product-addon-item');
    if (!productAddonItem) {
        console.warn('Product addon item not found');
        return;
    }

    // Get variants data from the data attribute
    const variantsData = productAddonItem.getAttribute('data-variants');
    if (!variantsData) {
        console.warn('Variants data not found on product addon');
        return;
    }

    try {
        const variants = JSON.parse(variantsData);
        
        // Find and update Gift Message title
        const giftMessageTitleEl = document.getElementById('gift-message-title');
        if (giftMessageTitleEl) {
            const giftMessageVariant = variants.find(v => 
                v.title.toLowerCase().includes('gift message')
            );
            if (giftMessageVariant) {
                giftMessageTitleEl.textContent = giftMessageVariant.title;
                // Store variant ID for checkout
                giftMessageTitleEl.setAttribute('data-variant-id', giftMessageVariant.id);
            }
        }

        // Find and update Gift Image title
        const giftImageTitleEl = document.getElementById('gift-image-title');
        if (giftImageTitleEl) {
            const giftImageVariant = variants.find(v =>
                v.title.toLowerCase().includes('gift image')
            );
            if (giftImageVariant) {
                giftImageTitleEl.textContent = giftImageVariant.title;
                // Store variant ID for checkout
                giftImageTitleEl.setAttribute('data-variant-id', giftImageVariant.id);
            }
        }

        console.log('Popup prices updated successfully', variants);
    } catch (error) {
        console.error('Error parsing variants data:', error);
    }
    
    // Also update occasions
    updatePopupOccasions();
}

// Update popup occasions dynamically
function updatePopupOccasions() {
    const productAddonItem = document.querySelector('.product-addon-item');
    const occasionSelect = document.getElementById('OccasionSelect');
    
    if (!productAddonItem || !occasionSelect) return;

    const occasionsData = productAddonItem.getAttribute('data-occasions');
    if (!occasionsData) return;

    try {
        const occasions = JSON.parse(occasionsData);
        
        // Keep the first default option "Choose an occasion"
        // It usually has value=""
        const defaultOption = occasionSelect.querySelector('option[value=""]');
        
        // Clear existing options
        occasionSelect.innerHTML = '';
        
        // Add back default option if it existed, otherwise create one
        if (defaultOption) {
            occasionSelect.appendChild(defaultOption);
        } else {
            const opt = document.createElement('option');
            opt.value = "";
            opt.text = "Choose an occasion";
            opt.disabled = true;
            opt.selected = true;
            occasionSelect.appendChild(opt);
        }
        occasions.forEach(occasion => {
            const occasionNamesString = String(occasion.name || '');
            if (occasionNamesString.trim() === '') {
                console.warn(`Skipping occasion entry: ${JSON.stringify(occasion)} - 'name' field is empty.`);
                return; // Skip this Metaobject entry and move to the next one
            }
            const individualOccasions = occasionNamesString
                .split(',') // Split by comma
                .map(s => s.trim()); // Remove leading/trailing spaces
                // .filter(s => s.length > 0); // Remove any empty results
            individualOccasions.forEach(name => {
                const opt = document.createElement('option');                
                opt.value = name; 
                opt.text = name;
                occasionSelect.appendChild(opt);
            });
        });
        
        console.log('Popup occasions updated successfully', occasions);
    } catch (error) {
        console.error('Error parsing occasions data:', error);
    }
}



// const saveBtn = document.getElementById('save-gift-wrap');
const saveAddToCartBtn = document.querySelector('#save-add-to-cart');
const msgCheckbox = document.getElementById('gift-wrap-message');
const msgInput = document.getElementById('gift-wrap-message-input');
const senderName = document.getElementById('sender-name');
const recipientName = document.getElementById('recipient-name');
const occasionSelect = document.getElementById('OccasionSelect');
const gift_wrap_message_wrapper = document.getElementById('gift_wrap_message_wrapper');
const gift_wrap_image_wrapper = document.getElementById('gift_wrap_image_wrapper');

const imgCheckbox = document.getElementById('gift-wrap-image');
const imgFileInput = document.getElementById('gift-wrap-image-input');

// Hidden Inputs Selectors (Destination)
const hiddenMsgInput = document.getElementById('message-input');
const hiddenImgInput = document.getElementById('image-file');
const hiddenOccasionInput = document.getElementById('hidden-occasion');
const hiddenSenderNameInput = document.getElementById('hidden-sender-name');
const hiddenRecipientNameInput = document.getElementById('hidden-recipient-name');

// ----- Main Function: Validation & Save -----
function clearErrors() {
    const errors = document.querySelectorAll('.gift-error-msg');
    errors.forEach(err => err.remove());
}

function showError(element, message) {
    const errorDiv = document.createElement('div');
    errorDiv.className = 'gift-error-msg';
    errorDiv.textContent = message;
    errorDiv.style.color = 'red';
    errorDiv.style.marginTop = '5px';
    
    if (element.parentNode) {
        element.parentNode.insertBefore(errorDiv, element.nextSibling);
    }
}

function validateAndSaveData(event) {
    event.preventDefault();
    clearErrors();

    let isValid = true;

    if (msgCheckbox.checked) {
        if (msgInput.value.trim() === "") {
            showError(msgInput, "Please enter a gift message.");
            isValid = false;
        }
        if (senderName.value.trim() === "") {
            showError(senderName, "Please enter a sender name.");
            isValid = false;
        }
        if (recipientName.value.trim() === "") {
            showError(recipientName, "Please enter a recipient name.");
            isValid = false;
        }
    }

    if (imgCheckbox.checked) {
        if (imgFileInput.files.length === 0) {
            const fileLabel = document.querySelector('.gift-wrap-file-label');
            showError(fileLabel, "Please select an image to upload.");
            isValid = false;
        }
        if (occasionSelect.value.trim() === "") {
            showError(occasionSelect, "Please select an occasion.");
            isValid = false;
        }
    }
    if(!msgCheckbox.checked && !imgCheckbox.checked) {
        showError(gift_wrap_message_wrapper, "Please select at least one option.");
        showError(gift_wrap_image_wrapper, "Please select at least one option.");
        isValid = false;
    }
    if (!isValid) {
        return false;
    }

    if (msgCheckbox.checked) {
        hiddenMsgInput.value = msgInput.value;
        hiddenSenderNameInput.value = senderName.value;
        hiddenRecipientNameInput.value = recipientName.value;
    } else {
        hiddenMsgInput.value = "";
        hiddenSenderNameInput.value = "";
        hiddenRecipientNameInput.value = "";
    }

    if (imgCheckbox.checked && imgFileInput.files.length > 0) {
        hiddenImgInput.value = imgFileInput.files[0].name;
        hiddenOccasionInput.value = occasionSelect.value;
    } else {
        hiddenImgInput.value = "";
        hiddenOccasionInput.value = "";
    }
    // Close popup after saving data
    closePopupOnly();

    console.log("Data Saved Successfully!");
    console.log("Message:", hiddenMsgInput.value);
    console.log("Image Name:", hiddenImgInput.value);
    console.log("Occasion:", hiddenOccasionInput.value);
    console.log("Sender Name:", hiddenSenderNameInput.value);
    console.log("Recipient Name:", hiddenRecipientNameInput.value);

    return true;
}

// if (saveBtn) {
//     saveBtn.addEventListener('click', validateAndSaveData);
// }

if (saveAddToCartBtn) {
    saveAddToCartBtn.addEventListener('click', (e) => {
        const saved = validateAndSaveData(e);
        if (saved) {
            console.log("Proceeding to Add to Cart...");
            if (originalAddtoCartBtn) {
                // Generate and inject unique Gift Link ID
                const giftLinkId = generateGiftLinkId();
                const form = originalAddtoCartBtn.closest('form');
                
                if (form) {
                    const existingInput = form.querySelector('input[name="properties[_GiftLink]"]');
                    if (existingInput) existingInput.remove();

                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'properties[_GiftLink]';
                    input.value = giftLinkId;
                    form.appendChild(input);
                }

                mainCheckbox.checked = false; 
                setTimeout(() => {
                    originalAddtoCartBtn.click();
                }, 200);
            
                setTimeout(() => {
                    addGiftWrapToCart(giftLinkId);
                }, 1000);
            }
        }
    });
}

// Get the correct gift wrap variant ID based on selected options
function getCorrectGiftVariantId() {
    const productAddonItem = document.querySelector('.product-addon-item');
    if (!productAddonItem) return null;

    const variantsData = productAddonItem.getAttribute('data-variants');
    if (!variantsData) return null;

    try {
        const variants = JSON.parse(variantsData);
        
        // Check what options are selected (use saved states)
        const occasion = hiddenOccasionInput.value;
        const senderName = hiddenSenderNameInput.value;
        const recipientName = hiddenRecipientNameInput.value;
        const hasMessage = hiddenMsgInput.value;
        const hasImage = hiddenImgInput.value;

        let matchedVariant = null;

        if (occasion && senderName && recipientName && hasMessage && hasImage) {
            console.warn("Both message and image are selected");
            // Look for variant with both "message" and "image" in title
            matchedVariant = variants.find(v => {
                const title = v.title.toLowerCase();
                return title.includes('message') && title.includes('image');
            });
        }
        
        if (senderName && recipientName && hasMessage && !hasImage && !occasion) {
            // Look for variant with "message" in title (but not "image" if possible)
            matchedVariant = variants.find(v => {
                const title = v.title.toLowerCase();
                return title.includes('message');
            });
            // Fallback to any message variant
            if (!matchedVariant) {
                matchedVariant = variants.find(v => v.title.toLowerCase().includes('message'));
            }
        }
        
        if (!senderName && !recipientName && !hasMessage && hasImage && occasion) {
            // Look for variant with "image" in title (but not "message" if possible)
            matchedVariant = variants.find(v => {
                const title = v.title.toLowerCase();
                return title.includes('image');
            });
            // Fallback to any image variant
            if (!matchedVariant) {
                matchedVariant = variants.find(v => v.title.toLowerCase().includes('image'));
            }
        }
        
        if (!matchedVariant) {
            // Default/basic gift wrap - look for "default" or "basic" or first variant
            matchedVariant = variants.find(v => {
                const title = v.title.toLowerCase();
                return title.includes('default') || title.includes('gift wrap') || title.includes('basic') || title.includes('standard');
            });
            // Fallback to first available variant
            if (!matchedVariant && variants.length > 0) {
                matchedVariant = variants.find(v => v.title.toLowerCase().includes('default') || v.title.toLowerCase().includes('basic') || v.title.toLowerCase().includes('standard'));
            }
        }

        console.log('Selected gift variant:', matchedVariant, { hasMessage, hasImage });
        return matchedVariant ? matchedVariant.id : null;
    } catch (error) {
        console.error('Error selecting gift variant:', error);
        return null;
    }
}

// Add gift wrap product to cart with correct variant and properties
function addGiftWrapToCart(giftLinkId = null) {
    const variantId = getCorrectGiftVariantId();
    if (!variantId) {
        console.warn('No gift variant ID found');
        return;
    }

    const properties = getGiftLineItemProperties();

    // Create FormData for file upload support
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    // Append properties
    Object.keys(properties).forEach(key => {
        const value = properties[key];
        if (value !== null && value !== undefined && value !== '') {
            formData.append(`properties[${key}]`, value);
        }
    });

    // Add linking properties if ID exists
    if (giftLinkId) {
        formData.append('properties[_GiftLink]', giftLinkId);
        formData.append('properties[_IsGiftWrap]', 'true');
    }

    console.log('Adding gift wrap to cart via FormData');

    // Set flag to prevent orphan check during gift wrap addition
    isAddingGiftWrap = true;
    lastGiftWrapAddTime = Date.now();

    fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    })
    .then(data => {
        console.log('Gift wrap product added to cart:', data);

        // Fetch full cart to ensure refreshGlobalCartState has correct item_count
        fetch(window.Shopify.routes.root + 'cart.js')
            .then(res => res.json())
            .then(cart => {
                refreshGlobalCartState(cart);

                // Clear the flag after a delay to allow cart to fully update
                setTimeout(() => {
                    isAddingGiftWrap = false;
                    console.log('Gift wrap addition complete, orphan checks re-enabled');
                }, 2000);
            })
            .catch(err => {
                console.error('Error fetching cart after adding gift wrap:', err);
                isAddingGiftWrap = false;
            });

        console.warn('Refresh cart ui function called:');
    })
    .catch(error => {
        console.error('Error adding gift wrap product to cart:', error);
        isAddingGiftWrap = false;
    });
}

// Robust Cart UI Refresh (Handles Drawer, Page, and Empty States)
function refreshGlobalCartState(updatedCart) {
    const sectionsToFetch = ['cart-icon-bubble'];
    const cartDrawer = document.querySelector('cart-drawer');
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (cartDrawer) sectionsToFetch.push('cart-drawer');
    if (mainCartItems) sectionsToFetch.push('main-cart-items');
    if (mainCartFooter) sectionsToFetch.push('main-cart-footer');

    // 1. Fetch updated sections
    fetch(`${window.Shopify.routes.root}cart?sections=${sectionsToFetch.join(',')}`)
        .then(res => res.json())
        .then(sections => {
            // 2. Update DOM and Toggle Empty States
            const isEmpty = updatedCart.item_count === 0;
            const onCartPage = window.location.pathname.includes('/cart');

            // Update Cart Drawer
            if (cartDrawer && sections['cart-drawer']) {
                // Prevent drawer opening if on cart page (renderContents calls open())
                if (!onCartPage && typeof cartDrawer.renderContents === 'function') {
                    cartDrawer.renderContents({ sections: sections });
                } else {
                    // Manual update that doesn't trigger open()
                    const inner = cartDrawer.querySelector('.drawer__inner');
                    if (inner) {
                        // Extract specific HTML if typical section response, or just use as is
                        const dom = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                        const newInner = dom.querySelector('.drawer__inner');
                        if (newInner) {
                            inner.innerHTML = newInner.innerHTML;
                        } else {
                            inner.innerHTML = sections['cart-drawer'];
                        }
                    }
                }
                // Explicitly toggle empty class
                cartDrawer.classList.toggle('is-empty', isEmpty);
                const drawerInner = cartDrawer.querySelector('.drawer__inner');
                if (drawerInner) drawerInner.classList.toggle('is-empty', isEmpty);
            }

            // Update Main Cart Page Items
            if (mainCartItems && sections['main-cart-items']) {
                mainCartItems.classList.toggle('is-empty', isEmpty);
                
                const newDom = new DOMParser().parseFromString(sections['main-cart-items'], 'text/html');
                const newCartItems = newDom.querySelector('cart-items');
                const existCartItems = mainCartItems.querySelector('cart-items');
                
                if (existCartItems && newCartItems) {
                    existCartItems.replaceWith(newCartItems);
                } else {
                     mainCartItems.innerHTML = sections['main-cart-items'];
                }
                
                // Ensure cart-items custom element specifically gets the class (crucial for some themes)
                const currentCartItems = document.querySelector('cart-items');
                if (currentCartItems) currentCartItems.classList.toggle('is-empty', isEmpty);
            }

            // Update Main Cart Footer
            if (mainCartFooter) {
                 mainCartFooter.classList.toggle('is-empty', isEmpty);
                 if (sections['main-cart-footer']) {
                    const newDom = new DOMParser().parseFromString(sections['main-cart-footer'], 'text/html');
                    const selector = '.js-contents';
                    const newContent = newDom.querySelector(selector);
                    const oldContent = mainCartFooter.querySelector(selector);
                    
                    if (newContent && oldContent) {
                        oldContent.replaceWith(newContent);
                    } else {
                        mainCartFooter.innerHTML = sections['main-cart-footer'];
                    }
                 }
            }

            // Update Cart Icon
            if (sections['cart-icon-bubble']) {
                const iconBubble = document.getElementById('cart-icon-bubble');
                if (iconBubble) iconBubble.innerHTML = sections['cart-icon-bubble'];
            }

            // 3. Publish Global Update Event
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                 publish(PUB_SUB_EVENTS.cartUpdate, { 
                     source: 'custom-gift-card', 
                     cartData: updatedCart 
                 });
            }

            console.log('Global Cart State Refreshed', { isEmpty, sectionsUpdated: sectionsToFetch });
        })
        .catch(err => console.error('Error refreshing global cart state:', err));
}

// Build line item properties for gift wrap
function getGiftLineItemProperties() {
    const properties = {};
    
    if (hiddenMsgInput) {
        properties['Gift Sender Name'] = hiddenSenderNameInput.value;
        properties['Gift Recipient Name'] = hiddenRecipientNameInput.value;
        properties['Gift Message'] = hiddenMsgInput.value;
    }
    
    if (hiddenImgInput) {
        const imageInput = document.getElementById('gift-wrap-image-input');
        if (imageInput && imageInput.files && imageInput.files[0]) {
            // Append the actual File object, not just the name
            properties['Gift Image Url'] = imageInput.files[0];
            properties['Gift Occasion'] = hiddenOccasionInput.value;
        }
    }    
    return properties;
}

if (originalAddtoCartBtn) {
    originalAddtoCartBtn.addEventListener('click', (event) => {
        if (event.isTrusted && mainCheckbox && mainCheckbox.checked) {
            // Add gift wrap product to cart after the main product
            setTimeout(() => {
                addGiftWrapToCart();
            }, 1000);
        }
    });
}

// Generate unique ID for linking products
function generateGiftLinkId() {
    return 'gl_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
}

// -----------------------------------------------------
// Auto-Removal Logic for Orphaned Gift Wraps
// -----------------------------------------------------

// Tracking variables for safe orphan removal
let isAddingGiftWrap = false;
let orphanCheckDebounceTimer = null;
let lastGiftWrapAddTime = 0;
let lastCartItemCount = 0;

function checkAndRemoveOrphanedGiftWraps(cart, isRemovalAction = false) {
    if (!cart || !cart.items) return;

    // Track if cart size decreased (item was removed)
    const currentItemCount = cart.item_count || 0;
    const itemsWereRemoved = lastCartItemCount > currentItemCount;
    lastCartItemCount = currentItemCount;

    // Don't check for orphans if we're currently adding a gift wrap
    if (isAddingGiftWrap && !isRemovalAction) {
        console.log('Skipping orphan check: gift wrap is being added');
        return;
    }

    // Don't check for orphans within 3 seconds of adding a gift wrap
    // UNLESS this is a removal action or items were actually removed
    const timeSinceLastAdd = Date.now() - lastGiftWrapAddTime;
    if (timeSinceLastAdd < 3000 && !isRemovalAction && !itemsWereRemoved) {
        console.log('Skipping orphan check: too soon after gift wrap addition (' + timeSinceLastAdd + 'ms)');
        return;
    }

    if (isRemovalAction || itemsWereRemoved) {
        console.log('Processing orphan check immediately (removal detected)');
    }

    const items = cart.items;
    const mainProductLinks = new Set();
    const giftWraps = [];

    // 1. Identify valid links from main products
    items.forEach(item => {
        const props = item.properties || {};
        // Check for _GiftLink on items that are NOT gift wraps
        // Note: property keys might be case sensitive or handled differently depending on theme
        // We look for the exact keys we set.
        if (props._GiftLink && props._IsGiftWrap !== 'true') {
            mainProductLinks.add(props._GiftLink);
        }
    });

    // 2. Identify orphaned gift wraps
    items.forEach(item => {
        const props = item.properties || {};
        if (props._IsGiftWrap === 'true' && props._GiftLink) {
            if (!mainProductLinks.has(props._GiftLink)) {
                giftWraps.push(item.key); // Use item.key (line item key) for reliable removal
            }
        }
    });

    // 3. Remove orphans
    if (giftWraps.length > 0) {
        console.log('Removing orphaned gift wraps:', giftWraps);

        const updates = {};
        giftWraps.forEach(key => {
            updates[key] = 0;
        });

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
        .then(res => res.json())
        .then(updatedCart => {
            console.log('Orphans removed successfully', updatedCart);
            // Refresh UI robustly
            refreshGlobalCartState(updatedCart);
        })
        .catch(err => console.error('Error removing orphaned gift wraps:', err));
    }
}

// Debounced version of orphan check to prevent excessive calls
function debouncedOrphanCheck(cart, isRemovalAction = false) {
    // If this is a removal action, check immediately without debouncing
    if (isRemovalAction) {
        checkAndRemoveOrphanedGiftWraps(cart, true);
        return;
    }

    if (orphanCheckDebounceTimer) {
        clearTimeout(orphanCheckDebounceTimer);
    }

    orphanCheckDebounceTimer = setTimeout(() => {
        checkAndRemoveOrphanedGiftWraps(cart, false);
    }, 1500); // Wait 1.5 seconds before checking
}

// Subscribe to global cart updates
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
        // data might contain source, cartData, etc.
        if (data && data.cartData) {
            debouncedOrphanCheck(data.cartData);
        } else {
            // Fallback: fetch cart if data not provided
            fetch(window.Shopify.routes.root + 'cart.js')
                .then(res => res.json())
                .then(cart => debouncedOrphanCheck(cart))
                .catch(err => console.error('Error fetching cart for orphan check:', err));
        }
    });
}

// -----------------------------------------------------
// Enhanced Cart Monitoring for Third-Party Cart Apps
// -----------------------------------------------------

// Monitor cart drawer opening (for apps like Corner Cart Drawer)
function setupCartDrawerMonitoring() {
    // Watch for cart drawer being opened
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' &&
                (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
                const target = mutation.target;

                // Check if cart drawer became visible
                if (target.classList.contains('cart-drawer') ||
                    target.id === 'CartDrawer' ||
                    target.id === 'corner-cowi-open-primary-card') {

                    const isVisible = target.classList.contains('active') ||
                                      target.classList.contains('open') ||
                                      target.style.display !== 'none';

                    if (isVisible) {
                        console.log('Cart drawer opened, checking for orphaned gift wraps...');
                        fetch(window.Shopify.routes.root + 'cart.js')
                            .then(res => res.json())
                            .then(cart => debouncedOrphanCheck(cart))
                            .catch(err => console.error('Error checking orphans on drawer open:', err));
                    }
                }
            }
        });
    });

    // Observe the document body for cart drawer changes
    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        subtree: true
    });
}

// Intercept fetch calls to monitor cart updates from third-party apps
const originalFetch = window.fetch;
window.fetch = function(...args) {
    const url = args[0];

    // Check if this is a cart update request
    if (typeof url === 'string' &&
        (url.includes('/cart/update') ||
         url.includes('/cart/change') ||
         url.includes('/cart/add'))) {

        // Detect if this is likely a removal (update or change typically used for removal/quantity change)
        const isLikelyRemoval = url.includes('/cart/update') || url.includes('/cart/change');

        return originalFetch.apply(this, args).then(response => {
            // Clone the response so we can read it
            const clonedResponse = response.clone();

            // Check for orphans after cart update
            clonedResponse.json()
                .then(data => {
                    console.log('Cart updated via fetch, checking orphans...');
                    // Delay slightly to ensure DOM is updated
                    setTimeout(() => {
                        fetch(window.Shopify.routes.root + 'cart.js')
                            .then(res => res.json())
                            .then(cart => debouncedOrphanCheck(cart, isLikelyRemoval))
                            .catch(err => console.error('Error checking orphans after fetch:', err));
                    }, isLikelyRemoval ? 300 : 500); // Faster check for removals
                })
                .catch(() => {
                    // Response might not be JSON, ignore
                });

            return response;
        });
    }

    return originalFetch.apply(this, args);
};

// Monitor cart remove buttons for Corner Cart Drawer
document.addEventListener('click', function(event) {
    // Check if clicked element or parent is a cart remove button
    const removeButton = event.target.closest('[data-remove-item], .cart-remove-button, [href*="cart/change"]');

    if (removeButton) {
        console.log('Cart remove button clicked, will check for orphans immediately...');

        // Wait briefly for the removal to complete, then check immediately
        setTimeout(() => {
            fetch(window.Shopify.routes.root + 'cart.js')
                .then(res => res.json())
                .then(cart => debouncedOrphanCheck(cart, true)) // Pass true for immediate removal check
                .catch(err => console.error('Error checking orphans after removal:', err));
        }, 300); // Reduced delay for faster removal
    }
}, true); // Use capture phase to catch early

// Initialize monitoring when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCartDrawerMonitoring);
} else {
    setupCartDrawerMonitoring();
}

// Check for orphans on page load (cleanup any existing orphaned items)
window.addEventListener('load', function() {
    console.log('Page loaded, performing initial orphan check...');

    // Initialize cart item count
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cart => {
            lastCartItemCount = cart.item_count || 0;
            console.log('Initial cart item count:', lastCartItemCount);

            // Perform initial orphan check after delay
            setTimeout(() => {
                debouncedOrphanCheck(cart);
            }, 2000);
        })
        .catch(err => console.error('Error during initial cart check:', err));
});

console.log('Enhanced gift wrap orphan removal system initialized');